"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guardianInviteUserFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const persona_1 = require("../../../../mocks/persona");
const guardian_invite_persona_factory_1 = require("./guardian-invite-persona.factory");
exports.guardianInviteUserFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    uuid: Factory.each(() => uuid_1.v4()),
    email_address: persona_1.persona.email,
    self_persona: guardian_invite_persona_factory_1.guardianInvitePersonaFactory.build(),
});
